import { atom } from "recoil";
export const FactoryData = atom({
    key: "FactoryData", // unique ID (with respect to other atoms/selectors)
    default: [], // default value (aka initial value)
});
